import axios from 'axios';

export async function generateShareLink({reportUrl}) {
  const {data} = await axios.post('/api/reports/share-link', {
    reportUrl,
  }, {_hideErrors: true});

  return data.shareUrl;
}

const ShareLinkApiDefaults = {generateShareLink};

export default ShareLinkApiDefaults;
